export const DINEOUT_THEME_QUERY_VALUE = "umami";
export const THEME_QUERY_PARAM = "theme";

export const BASE_PROVIDER_THEME = "base";
export const DINEOUT_PROVIDER_THEME = "dineout";

export enum AppColorMode {
    Light = "light",
    Dark = "dark",
}
